@if (visible()) {
  <div
    class="relative flex h-8 shrink-0 items-center justify-center gap-2.5 rounded-full bg-zinc-750 px-10 font-brand text-xs font-medium tracking-tight text-zinc-200"
    role="status"
    [vRequiredRoles]="['subscriptions.manager']">
    <span class="truncate">
      @if (daysLeft() === 0) {
        {{ 'components.trialBanner.endsToday' | transloco }}
      } @else {
        {{
          'components.trialBanner.daysLeft' | transloco: { days: daysLeft() }
        }}
      }
    </span>
    <a
      class="shrink-0 rounded-full bg-zinc-600 px-2.5 py-1.5 leading-none text-zinc-200 hover:bg-zinc-500 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      routerLink="/settings/organization/subscription">
      {{ 'components.trialBanner.upgrade' | transloco }}
    </a>
    @if (closable()) {
      <vx-icon-button
        class="absolute right-1"
        icon="x"
        variant="ghost"
        tone="secondary"
        size="sm"
        [ariaLabel]="'components.trialBanner.dismiss' | transloco"
        (click)="dismiss()" />
    }
  </div>
}
